module.exports = __webpack_public_path__ + "static/Grupo 81-34e0c9d0d13e6b2da3ec6b040b2df7d2.svg";